// extracted by mini-css-extract-plugin
export default {"more":"MoreBtn_more__dgCjG","more_card":"MoreBtn_more_card__C+Ba7","more_item":"MoreBtn_more_item__kPDx0"};